<template>
    <div class="privacyPage">
        <header class="mainHeader">
            <div class="mainHeader__inner">
                <img src="https://www.tcl.eu/bundles/tclapp/img/logo/tcl.svg" width="175" height="49" alt="TCL The Creative Life">
            </div>
        </header>

        <main class="mainCenter">
            <section class="stage">
                <div class="stage__bg" style="background-image: url('https://dmayeb5ar6kq1.cloudfront.net/common/5afe96406f1ca_591efa86bf9d0_COMPARATEUR.jpg')"></div>
                <div class="mainContent__center">
                    <div class="grid">
                        <div class="grid__col-6 grid__col-md-12 grid--order-0-md grid--align-center">
                            <div class="stage__text">
                                <h1 class="tl1">
                                    プライバシー通知　－　スマートテレビ・サービス
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="mainContent__section">
                <div class="mainContent__center">
                    <p>
                        当社はお客様の個人データを取り扱う際、プライバシーを尊重します。本プライバシー通知は、当社のスマートテレビサービス（以下「本サービス」といいます。）の利用に関連して当社がお客様から収集する個人データの処理について責任を負う事業体、当社がお客様についてどのような種類の個人データを収集するか、当社がそれについて何を行うか、及び当社による個人データの使用に係るお客様の権利について、説明します。
                    </p>

                    <h3>
                        1.	データ管理者
                    </h3>
                    <p>
                        本サービスをご利用される際に、お客様から収集する個人データの収集、処理及び使用は、中華人民共和国広東省深圳市蛇口工業区工業大道中5号に所在する深圳TCL新技術有限公司（以下「当社」といいます。）但し、当社は以下に定めるデータ処理の全てについて責任を負うものではないことに留意してください。しかしながら、かかる処理は、お客様によるスマートテレビのご利用に関係しますので、各処理に関する説明について、当社のプライバシー通知に記載しました。
                    </p>

                    <h3>
                        2.	データ処理の承諾
                    </h3>
                    <p>
                        当社が実施するお客様のデータの処理活動の中には、お客様の承諾を必要とするものがあります。例えば、本サービスを改善する目的でのお客様のデータを使用することなどです。
                    </p>
                    <p>
                        承諾は任意ですので、お客様は、承諾されなくても本サービスをご利用になれますが、お客様の嗜好に合っていないコンテンツが表示される場合があります。お客様の承諾の有無に関わりなく、当社は、適用法令により許容される範囲内で、お客様の個人データを処理する権利を留保します。
                    </p>
                    <p>
                        お客様はいつでも承諾を撤回することができます。承諾の撤回は、撤回前の承諾に基づく処理の適法性には影響を与えません。承諾の撤回及び／又は異議（お客様の異議を申し立てる権利については、後述の第10条及び別表「お客様の権利」を参照してください。）は、適宜、お客様のスマートテレビのプライバシー設定を変更して行ってください。
                    </p>

                    <h3>
                        3.	特別な種類の個人データ
                    </h3>
                    <p>
                        当社は、以下の特別の種類のデータを処理します。
                    </p>
                    <p>
                        デバイスID:　お客様のスマートテレビには固定の固有番号が格納されており、これにより、お客様が本サービスをご利用される際に、当社がスマートテレビを識別及び認証することができます。この番号はデバイスIDといいます。
                    </p>
                    <p>
                        IPアドレス及びMACアドレス：　インターネットにアクセスする際、お客様のスマートテレビにIPアドレスが割り当てられます。お客様のスマートテレビがルーターの内側（例えば、ローカル・ホーム・ネットワーク又はローカルWLAN内）にある場合、当社は、当該ルーターのIPアドレスを処理する場合があります。MACアドレスは、お客様のスマートテレビの各ネットワーク・インターフェイスに割り当てられる固有の番号です。
                    </p>
                    <p>
                        デバイス特有の情報：　スマートテレビはそれ自体及びその構成に関する各種情報を保存します。これらの情報は、スマートテレビの種類、スマートテレビのオペレーティング・システムのバージョン、そのパネルの解像度、プロジェクトID（すなわち、構成ファイルに関する情報）、ユーザー・エージェント、ブラウザ名、ブラウザのバージョン、並びに、スマートテレビに設定された言語及び国を含みます。
                    </p>
                    <p>
                        これらの情報は、当社が使用し、かつ、以下の目的で、当社のサービス・パートナー及びコンテンツ・パートナーにも提供されます。
                    </p>

                    <h3>
                        4.	お客様の個人データを当社が処理及び／又は使用する目的及び法的根拠
                    </h3>
                    <p>
                        当社がお客様の個人データを処理する目的及びその法的根拠は以下の通りです。法的根拠として以下に記載する契約上の目的の範囲内で、お客様から当社に対し各データをご提供いただけない場合、当社はお客様に本サービスを提供できません。お客様の承諾が法的根拠である場合には、お客様は任意にお客様の承諾を提供又は撤回できます。お客様が承諾されない場合、当社は各目的のためにお客様の個人データを処理しません。
                    </p>
                    <ul>
                        <li>
                            本サービスの提供：　当社は、お客様のスマートテレビが、本サービス及びコンテンツ・パートナーの提供するサービスにアクセスするために、IPアドレス及びMACアドレス、デバイスID、スマートテレビのオペレーティング・システムのバージョン、お客様のスマートテレビの顧客タイプ及びそのパネル解像度、プロジェクトID（すなわち構成ファイルに関する情報）、お客様のDTVチャンネルリスト、閲覧したチャンネル、タイムゾーン、国及び言語の設定を使用します。目的には、位置情報に基づくサービス（例えば天気予報）の提供、不正使用への対処、セキュリティ事故の管理、本サービスの可用性の監視、及びユーザー設定のバックアップサービスの提供が含まれます（但し、これらに限りません。）。
                        </li>
                        <p>
                            お客様が本サービスをご利用になられる際、お客様のスマートテレビは、インターネットを通じて、本サービスからのデータを要求します。これらの要求の一部として、上述のお客様のIPアドレス及びお客様のスマートテレビに設定された言語及び国が、当社のサービス・パートナーに送信されます。当社のサービス・パートナーは、そのプライバシー通知に従い、それぞれのデータを処理します。
                        </p>
                        <p>
                            お客様の個人データの各処理の法的根拠は、一般データ保護規則（GDPR）第6 (1) b) 条に基づく契約上の目的です。
                        </p>

                        <li>
                            サービスの設定：　本サービスの標準機能の一部として、お客様は、本サービスにより表示されるアプリケーションの配置を手動でカスタマイズすることができます。当社のサービス・パートナーは、お客様による配置及びお客様が本サービスをご利用中に設定されたその他の選好について保存します。この情報はデバイスIDにリンクされます。
                        </li>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) b) 条に基づく契約上の目的です。
                        </p>

                        <li>
                            認証：　お客様がお客様のスマートテレビをインターネットに接続してスマートテレビを作動させる度に、お客様のスマートテレビは、自動的に、当社のサービス・パートナーにより管理される本サービスに接続されます。お客様のスマートテレビは、その後、本サービスへのアクセスが証明されたものとして認証されます。認証を目的として、本サービスは、お客様のスマートテレビに関する一つ又は複数の固有の数字の識別子を保存します。当社は、認証目的で、デバイスID及びMACアドレスを利用します。また、当社は、認証目的で選定されたコンテンツ・パートナーにデバイスIDを提供します。これらのコンテンツ・パートナーは、コンテンツ・パートナーが提供するサービスへのアクセスについてお客様のスマートテレビを認証するために、デバイスIDを使用します。
                        </li>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) b)条に基づく契約上の目的です。
                        </p>

                        <li>
                            リモート診断: 本サービスの一部として、当社は、お客様にリモート診断サービスを提供します。そのため、当社は、デバイスID、デバイス番号、シリアル番号、MACアドレス並びに欠陥のあるモジュール（アプリケーション、ミドルウェアシステム）により提供されるエラーログ、エラーコード及びエラー記述を自動的に処理します。
                        </li>
                        <p>
                            さらに、お客様が当社のカスタマーサポートにお電話をされる場合、お客様に対する事前の認証を条件として、サポート担当者は、お客様のテレビにリモートアクセスしてにリモート診断サービスを事前に設定することができます。この場合、カスタマーサポート担当者は、お客様のテレビ、ネットワーク、アプリケーション、及び保存されたデータファイルへのアクセス権を受け取り、デバイスID、デバイス番号、シリアル番号、MACアドレス、エラーログ、エラーコード、エラー内容、ターミナルID、インストールされているアプリ情報、テレビのスクリーンショット、接続されているUSB/ Bluetoothデバイス情報をテレビ並びに関係するアプリケーション及びデータの状況を評価する目的で処理する場合があります。エラーログは、テレビ番組履歴、音楽プレイリスト、ユーザー名及び放映に使用されている第三者のアプリが当該情報を暗号化していない場合にアプリのパスワード等の情報を含む場合があります。これは、問題の診断、お客様の要請に基づくシステム設定の変更又は報告された問題の修正をするために行われます。また、要請に応じて、カスタマーサポートメンバーは、トラブルシューティング、プログラムの起動又はソフトウェアのインストール/アンインストール、当該テレビ上で再設定及び/あるいはその他のサービス又はテクニカルサポート作業の実施をすることがあります。
                        </p>
                        <p>
                            リモートアクセスは、お客様が、お客様のテレビ上で指定されたチェックボックスにチェックを入れて、リモートサポート機能を有効化した後にのみ実施され、各セッション後に終了します。
                        </p>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) b) 条に基づく契約上の目的です。
                        </p>

                        <li>
                            アフターサービス: 適用法令に基づきお客様は保証又はアフターサービスを受けるための類似の権利を有することがあります。9-15 rue Rouget de L'Isle- 92130 Issy- Les-Moulineaux, Franceに所在するTCL Europeは、保証請求及びアフターサービスに関するその他の要求並びにそれらに付随するお客様の個人データの処理に対応する責任を負っています。すなわち、アフターサービスの目的で、TCL Europeはデータ管理者として活動し、当社はお客様の個人データの各処理について責任を負いません。
                        </li>
                        <p>
                            お客様が当社のアフターサービスに関するお問合せをする際、お客様にアフターサービスを提供する目的で、請求書記載のお客様の氏名、電子メールアドレス、電話番号、サービスリクエスト及び郵便番号が必要になることがあります。また、お客様が当社の再販業者のアフターサービス提携先又は認定サービス提供会社にサービスに関するお電話をされると、これらの会社を通じて情報が収集されることがあります。アフターサービスに関する個人データ保護の詳細については、第12条に記載のTCL Europeの連絡先に問い合わせることができます。
                        </p>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) c) 条に基づく法的義務の遵守です。
                        </p>

                        <li>
                            T-Channel: T-Channelとは、Linux OS上のスマートテレビを利用するためのメイン画面で（アンドロイドOSについては後記をご覧ください）、お客様は特定のコンテンツを選択することができます。
                        </li>
                        <p>
                            お客様がT-Channelを利用する際に必要なお客様の個人データの各処理の法的根拠は、GDPR第6 (1) b) 条に基づく契約上の目的です。
                        </p>
                        <p>
                            お客様の事前の同意を条件として、当社は、T-Channelのご利用をモニタリングします。すなわち：
                            <ul>
                                <li>
                                    お客様がT-Channelの利用を開始すると、当社は、T-Channelの利用開始時間と終了時間を記録します。
                                </li>
                                <li>
                                    お客様がT-Channelのビデオ再生を開始すると、当社は、ビデオの名称と継続時間を記録します（Netflix、YouTube又はその他第三者が提供するサービスには適用されません）。
                                </li>
                                <li>
                                    お客様が当該画面を開始又は終了すると、当社は、当該画面での滞留時間を記録します。
                                </li>
                                <li>
                                    お客様がお客様のカーソルをある場所から別の場所へ動かしたり、アプリケーションに入力したりすると、当社はそれらの事象を記録します。
                                </li>
                                <li>
                                    お客様がアプリケーションをインストール、削除又はアップデートすると、当社は、アプリケーション名を含め、それらの事象を記録します。
                                </li>
                            </ul>
                        </p>
                        <p>
                            当社は、製品を改善して、ユーザーにより良いコンテンツ・サービスを提供するために、主としてビッグデータ分析のために、これらの情報を収集します。
                        </p>
                        <p>
                            お客様によるT-Channelの利用のモニタリングに関連してお客様の個人データを処理する法的根拠は、GDPR第6 (1) a) 条に基づくお客様の同意です。
                        </p>
                        <p>
                            お客様がAndroid TVを購入して、GoogleのアンドロイドOSを使用する場合、お客様の個人データは、Googleによって処理され、当社は、かかる処理に関する責任を負いません。お客様の個人データ関連する処理及びお客様各自の権利に関する情報については、Googleのプライバシー通知を参照してください。
                        </p>

                        <li>
                            T-Cast:　T-Castにより、お客様は、お客様の電話を使用してお客様のテレビを制御することができ、お客様のスマートフォンに保存されたビデオ、音楽及び写真をテレビ上で共有することができます。T-Castにより、お客様が、お客様のテレビにお客様のスマートフォンを映し出すこともできます。
                        </li>
                        <p>
                            アプリのダウンロードや使用は任意です。このアプリをダウンロードして使用すると、当社は、市場でT-Cast版がいくつ使われているか計算するために、MACアドレスを処理します。これはお客様にこのサービスを提供するために必要です。お客様が当社のセカンドスクリーン設定をご利用になられる場合、お客様が当該アプリケーション上で有効にされた制御、国及び言語の設定、dTVチャンネルリスト、お気に入りチャンネルリスト、スケジュールリスト、デバイスID、現在のチャンネル、プロトコルのバージョン、並びに、お客様のスマートテレビのIPアドレスは、当社のサーバー上で、当社により収集及び処理されます。当社のサーバーは、その後、アプリでお客様が指定された通りに、お客様のスマートテレビを制御します。
                        </p>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) b) 条に基づく契約上の目的です。
                        </p>

                        <li>
                            TCLアシスタント:　TCLアシスタントは、お客様の声で当該デバイスをコントロールするためにお客様のテレビをAmazon Alexa対応デバイス（例えばEcho）と接続するための機能です。この機能を利用するためには、お客様は、まず初めに、Amazonのウェブサイト上で、お客様のテレビに記載されているTCLコードを用いてお客様のテレビを登録することが必要です。お客様は、次に、お客様のテレビのリモコン上のマイクボタンを押して、Amazon Alexa対応デバイスに口頭で指示することができます。
                        </li>
                        <p>
                            お客様がTCLアシスタントをご利用される場合、お客様のテレビは、お客様の声を収集して声認識及び更なる処理のためにAmazon Alexaクラウドに送信します。お客様のデータは、直接Amazonに移転され、いかなるデータもお客様のテレビ上で更に処理又は保存されません。Amazonによるお客様のデータの更なる処理に関する情報については、Amazonのプライバシー通知を参照してください。
                        </p>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) b) 条に基づく契約上の目的です。
                        </p>

                        <li>
                            Alexa 声認識 (AVS):　 AVSは、お客様がお客様の声でテレビをコントロールするための機能です。この機能を利用するためには、お客様は、まず初めに、Amazonが発行する登録コードを用いてお客様のテレビをAmazonのウェブサイトに登録することが必要です。お客様は、次に、お客様のテレビのリモコン上のマイクボタンを押して、当該テレビに口頭で指示することができます。
                        </li>
                        <p>
                            お客様がAVSをご利用される場合、お客様のテレビは、お客様の声を収集して声認識及び更なる処理のためにAmazon Alexaクラウドに送信します。お客様のデータは、直接Amazonに移転され、いかなるデータもお客様のテレビ上には保存されません。Amazonによるお客様のデータの更なる処理に関する情報については、Amazonのプライバシー通知を参照してください。
                        </p>
                        <p>
                            お客様がAVSをご利用になる際、お客様がコントロールされたいテレビを当社が抽出するために、お客様のテレビの名称が要求されます。
                        </p>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) b) 条に基づく契約上の目的です。
                        </p>
                        <p>
                            さらに、当社は、お客様がどのくらい頻繁に、かつ、どのくらいの時間AVSをご利用になられたか、並びに、AVSのどの機能をお客様がご利用になられたかにつき記録します。当社は、製品の改善及びより良いコンテンツサービスのユーザーへのご提供のために、この情報を収集します。
                        </p>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) f) 条に基づく当社の正当な利益です。要請に応じて、バランシングテストに関する更なる情報をご提供いたします。
                        </p>

                        <li>
                            ソフトウエアの更新：　ソフトウェアの更新は本サービスの一部です。そのため、お客様のスマートテレビの電源が入れられる度に、利用可能なソフトウエアの更新の有無を確認するため、並びに、適切なソフトウエアの更新をお客様にご提案及びご提供するために、IPアドレス、デバイスID、デバイス番号、ソフトウエアのバージョン、お客様のスマートテレビの顧客タイプ、プロジェクトID（すなわち構成ファイル）、ユーザーID及びシリアル番号が当社に提供されます。
                        </li>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) b) 条に基づく契約上の目的です。
                        </p>

                        <li>
                            法律の執行：　当社は、管轄の法執行機関又は裁判所にデータを提出することを要求される場合があります。かかる場合、当社は、関連機関への当社の協力を要求する令状又は司法命令等の拘束力のある法的証書があるときに限り、その要求に応じます。
                        </li>
                        <p>
                            お客様の個人データの各処理の法的根拠は、GDPR第6 (1) c) 条に基づく当社の法的義務の遵守です。
                        </p>
                    </ul>

                    <p>
                        仮名の使用によっても本サービスを利用することができます。但し、特定のサービスにおいてお客様の氏名及び／又は電子メールアドレスの提供が求められる場合はこの限りではありません。
                    </p>

                    <h3>
                        5.	16歳未満の子供のプライバシー及び安全性
                    </h3>
                    <p>
                        当社は、当社の本サービスを利用して子供のプライバシー及び安全を保護するために特別な予防措置を講じることの重要性を理解しています。16歳未満又は関連する裁判管轄においてそれに相当する最低年齢の子供は、親が確認可能な同意を与えていない限り、テレビを介して又はアフターサービスに電話をする際に、個人情報を提供することはできません。
                    </p>
                    <p>
                        当社はユーザーの生年月日を収集することはないため、ユーザーの年齢を特定することはできません。しかし、当社が16歳未満又は裁判管轄に応じてそれに相当する最低年齢の子供の個人情報を収集したことが判明した場合、上記の状況外で、当社は、できるだけ早く情報を削除するように措置を講じます。
                    </p>

                    <h3>
                        6.	第三者のアプリ
                    </h3>
                    <p>
                        お客様のスマートテレビでは、Netflix、YouTubeなど、第三者が提供するアプリを使用できます。アプリストアからアプリをダウンロードしたり、既にお客様のデバイスにプレインストールされている第三者のアプリを起動したりすることができます。お客様のデバイスに予めインストールされている第三者のアプリケーションは、お客様の事前の承認を得ずに、個人情報を収集することはありません。例えば、Netflixは、既にデバイスにプレインストールされていますが、お客様がNetflixアカウントにログインすると、データを収集するだけです。HbbTVは、お客様がお客様のリモコンの指定されたボタンを押して収集に同意すると、データを収集するだけです。
                    </p>
                    <p>
                        第三者のアプリを有効にすると、お客様の個人情報は、アプリの提供者によって処理されることがあります。当社は、かかる処理について責任を負いません。関連するお客様のデータの処理及びお客様の各権利に関する情報については、第三者のアプリのプライバシーに関する通知を参照してください。
                    </p>

                    <h3>
                        7.	受領者のカテゴリー
                    </h3>
                    <p>
                        当社は、お客様が当該コンテンツ・パートナーの提供する特定のコンテンツを要求される場合に第三者コンテンツ・パートナーとの間で、あるいは本サービスの提供について当社を支援するデータ処理業者としての外部受託業者との間でのみ、お客様が本サービスをご利用中に収集されるお客様の個人データを共有します。
                    </p>
                    <p>
                        当社は、当社が法律上の要件に基づき共有が義務付けられる場合（例えば、裁判所又は検察当局に対して）、お客様が各共有について承諾した場合、又はその他共有が適用法令に基づき適法である場合にのみ、お客様の個人データをその他の第三者と共有します。
                    </p>

                    <h3>
                        8.	お客様のデータが処理される国
                    </h3>
                    <p>
                        当社及び／又は上記に列挙されたお客様の個人データの受領者の一部は、欧州経済地域外（例えば、中華人民共和国やアメリカ合衆国）に所在する可能性があります。従って、お客様の個人データは、データ保護法がお客様の裁判管轄の法律とは異なるレベルの保護を提供し、GDPRに従って十分なレベルの個人データの保護を提供しているとは認められていない国で処理される可能性があります。ヨーロッパのデータ保護法の観点から十分なレベルのデータ保護を提供しているものとして認識されている国々には、アンドラ、アルゼンチン、カナダ、スイス、フェロー諸島、ガーンジー、イスラエル、マン島、ジャージー、ニュージーランド、ウルグアイが含まれます。米国内の受領者の中には、EU-米国間プライバシー・シールドに基づき部分的に認証されていることがあり、ヨーロッパのデータ保護法の観点から、十分なレベルのデータ保護を提供しているものとして認識されることがあります。
                    </p>
                    <p>
                        必要に応じて、当社は、十分なレベルのデータ保護を提供していないEU域外の受領者へのデータ移転に関する適切な保護措置を実施します。各措置の写しは、後述の第12条に記載されている通り、当社に連絡して請求することができます。
                    </p>

                    <h3>
                        9.	保有期間
                    </h3>
                    <p>
                        お客様の個人データは、お客様に本サービスを提供するために必要な期間保有されます。ほとんどのデータについて、通常、当社は、お客様のデータを1ヶ月間保有します。 リモート診断やアフターサービスの目的で、お客様のデータを最長10年間保有することがあります。 契約上又は法的な義務を遵守するためにお客様の個人データを使用する必要がなくなった場合、当社のシステム及び記録から削除し、及び/又は適切に匿名化するための措置を取り、お客様が識別されないようにします。
                    </p>

                    <h3>
                        10.	お客様の権利
                    </h3>
                    <p>
                        適用のあるデータ保護法に従って、お客様の個人データへのアクセスを要求したり、お客様の個人データの訂正を要求したり、お客様の個人データの消去を要求したり、お客様の個人データの処理の制限を要求したり、データポータビリティを要求したり、お客様の個人データの処理に異議を述べたりする権利を有する場合があります。但し、上記の権利は、適用のある国内データ保護法の下で制限される場合があります。これらの権利の詳細については、後述の別紙「お客様の権利」を参照してください。
                    </p>
                    <p>
                        また、お客様は、管轄権を有するデータ保護監督機関に苦情を申し立てる権利も有しています。
                    </p>
                    <p>
                        お客様の権利を行使するには、後述の第12条に記載されている通り、当社にご連絡ください。
                    </p>

                    <h3>
                        11.	プライバシー通知の変更
                    </h3>
                    <p>
                        当社の本サービスを改善するため、当社は、本プライバシー通知の修正を必要とする場合があります（例えば、新技術又は新サービスの導入により）。当社は本プライバシー通知をいつでも変更又は補足する権利を留保します。
                    </p>

                    <h3>
                        12.	連絡先
                    </h3>
                    <p>
                        本プライバシー通知に関するご質問やお客様の個人データの当社による取扱いに関する苦情は、以下の連絡先宛てに当社までご連絡ください。
                    </p>
                    <p>
                        ご連絡方法： www.tcl.eu/en/contact-us
                    </p>
                    <p>
                        バージョン：2.0
                    </p>

                    <div class="stage__text">
                        <h1 class="tl1">
                            別紙 お客様の権利
                        </h1>
                    </div>
                    <ul>
                    <li>
                        a.	アクセス権:　お客様は、お客様の個人データが処理されるか否かについて当社の確認を取得し、且つ、かかる処理がなされる場合には、個人データへのアクセスを要求する権利を有することがあります。アクセス情報には、とりわけ、処理の目的、関連する個人データの種類、並びに、個人データが開示された又は開示される受領者又は受領者の種類が含まれます。但し、これは絶対的な権利ではなく、他の個人の利益によってお客様のアクセス権が制限される場合があります。
                    </li>
                    <p>
                        お客様は、処理中の個人データの写しを取得する権利を有する場合があります。追加の写しをご希望の場合、当社は、管理費用に基づいて合理的な手数料を請求することがあります。
                    </p>
                    <li>
                        b.	訂正権：　お客様は、お客様に関する不正確な個人データを当社に訂正させる権利を有することがあります。処理の目的に応じて、お客様は、補足的な記載の提供等により、不完全な個人データを完成させる権利を有することがあります。
                    </li>
                    <li>
                        c.	消去権（「忘れられる権利」）：　特定の状況の下で、お客様は、お客様に関する個人データを当社に削除させる権利を有し、且つ、当社は、かかる個人データを消去する義務を負うことがあります。
                    </li>
                    <li>
                        d.	処理を制限する権利：　特定の状況の下で、お客様は、お客様に関する個人データの処理の制限を要求する権利を有することがあります。この場合、各データに印が付けられ、特定の目的のために当社によってのみ処理されることがあります。
                    </li>
                    <li>
                        e.	データポータビリティ権：　特定の状況の下で、お客様は、お客様が当社に提供したお客様に関する個人データを、構造化された一般に使用されている機械可読性のある形式で受け取る権利を有し、且つ、お客様は、それらのデータを当社による妨害なしに他の会社に送信する権利を有することがあります。
                    </li>
                    <li>
                        f.	異議申立権: 特定の状況の下で、お客様は、お客様の特定の状況に関する根拠又はダイレクトマーケティング目的で個人データが処理される根拠について、お客様の個人データの当社による処理に対し、いつでも異議を申し立てる権利を有し、且つ、当社はお客様の個人データを処理しないように要求されることがあります。
                    </li>
                    <p>
                        更に、お客様は、お客様の個人データがダイレクトマーケティング目的で処理される場合（当該ダイレクトマーケティングに関連する範囲内でのプロファイリングを含みます。）、そのようなマーケティング目的のお客様に関する個人データの処理に対し、いつでも異議を申し立てる権利を有しています。この場合、当社は、当該目的で、お客様の個人データを処理することを止めます。
                    </p>
                    </ul>

                    <div class="stage__text">
                        <h1 class="tl1">
                            クッキー通知　-　スマートテレビ・サービス
                        </h1>
                    </div>
                    <p>
                        当社は、当社が製造したスマートテレビ及びこれにより提供された本サービスの利用に関し、お客様のプライバシーを尊重します。クッキーは、多くのウェブサイト及びその他のインターネットサービスにより使用されており、お客様のスマートテレビは、それらのウェブサイト及びサービスが適切に動作することを確実にするために、クッキーを受信、保存及び送信します。
                    </p>
                    <p>
                        当社は、お客様に本サービスを提供する際に、クッキーを使用しません。しかし、第三者（例えば、第三者のアプリ提供者など）は、お客様が彼らのサービスにアクセスするためにスマートテレビをご利用になる際、クッキーを使用することがあります。本クッキー通知は、第三者が配置することがあるクッキーに関する限定的な情報のみを提供することができます。第三者が使用する実際のクッキー及びそれらの機能に関する情報については、当社は、お客様に対し、かかる第三者の各クッキー通知を引用します。しかし、本クッキー通知において、当社は、お客様のスマートテレビに設定することができるクッキー及びお客様がそれらを管理する方法に関する一般的な説明を提供します。
                    </p>
                    <h3>
                        1.	クッキーとは何か？
                    </h3>
                    <p>
                        クッキーは、お客様のスマートテレビに設定される小さなテキストファイルです。テレビ局のウェブサイト又はレッドボタン・サービスにアクセスすると、当該ウェブサイト又はサービスは、スマートテレビにクッキーを保存する場合があります。その後のアクセスにおいて、お客様のスマートテレビに設定されたクッキーは、当該クッキーを設定した当事者に情報を送ります。クッキーは極めて一般的であり、多くのウェブサイト及びサービスで使用されています。各クッキーには通常、当該クッキーの発信元のドメイン名、クッキーの「寿命」及び値（通常は固有の番号）が含まれます。クッキーとは何か及びそれがどのように動作するかに関する更に詳細な説明については、www.allaboutcookies.org.をご覧ください。
                    </p>
                    <p>
                        クッキーは、機能性クッキーと非機能性クッキーとに分類することができます。機能性クッキーとは、お客様に本サービスを提供するために必要不可欠なクッキーです。非機能性クッキーとは、その他の全てのクッキーです。
                    </p>
                    <h3>
                        2.	第三者のウェブサイト
                    </h3>
                    <p>
                        お客様のスマートテレビの本サービスを通じて第三者のウェブサイト又はサービスを訪問する際、当該ウェブサイト又はサービスがお客様のスマートテレビにクッキーを設定し、かつ、当該ウェブサイトが当該ウェブサイトにおけるお客様の相互作用を追跡及び保存することがあります。当社はかかる活動を要求又は推奨せず、かかる情報を使用しません。当該当事者のかかるクッキーの使用に関する更なる情報については、当該ウェブサイト又はサービスの各クッキー及びプライバシー通知をご参照ください。
                    </p>
                    <h3>
                        3.	クッキーの削除
                    </h3>
                    <p>
                        お客様のスマートテレビのユーザーインターフェイスにより、スマートテレビから全てのクッキー及びその他のローカル・ブラウザのストレージを削除することができます。お客様のスマートテレビを売却又は譲渡する前に、全てのクッキー及びローカルに保存された設定を削除することが強く推奨されます。
                    </p>
                    <p>
                        バージョン：2.0
                    </p>
                </div>
            </section>
        </main>

        <footer class="mainFooter">
            <p> © 2018 TCL Inc. </p>
        </footer>
    </div>
</template>

<script>
export default {
    name: "PrivacyPolicy"
}
</script>

<style scoped>
.privacyPage h3 {
    position: relative;
    padding-bottom: 10px;
    margin-bottom: 25px;
    font-family: 'opensans_regular', sans-serif;
    font-size: 1.2em;
    font-size: 1.2rem;
    font-weight: normal;
    color: #262626;
    line-height: 1.25em;
}

p,
ul li {
    font-size: 0.92em;
    font-size: 0.92rem;
}

.privacyPage section {
    font: 1.2em/1.6em 'opensans_regular', sans-serif;
    color: #666;
    background-color: #FFF;
    line-height: 1.25em;
}

.privacyPage .mainHeader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    height: 54px;
    z-index: 999;
    background-color: #0d0d0d;
    transition: top 0.3s;
}

.privacyPage .mainHeader__inner {
    display: table;
    width: 100%;
    max-width: 1276px;
    margin: 0 auto;
    padding: 0 30px;
}

.privacyPage .mainCenter {
    max-width: 1276px;
    padding: 30px;
    padding-top: 60px;
    margin: 0 auto;
}


.privacyPage .mainContent__center {
    width: 100%;
    max-width: 1276px;
    margin: 0 auto;
    overflow: hidden;
}

.privacyPage .mainHeader__logo {
    position: relative;
    width: 105px;
    height: 55px;
    overflow: hidden;
}

.privacyPage .mainContent__center {
    width: 100%;
    max-width: 1276px;
    margin: 0 auto;
    overflow: hidden;
}

.privacyPage .stage {
    position: relative;
    padding: 30px 0;
    min-height: 330px;
}

.stage__bg {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
}

.view {
    padding-top: 54px;
}

footer {
    margin: 2rem auto;
    text-align: center;
}


/* .mainHeader__logo, .mainHeader__nav {
    display: table-cell;
    height: 100%;
    vertical-align: middle;
} */
</style>




// WEBPACK FOOTER //
// src/pages/PrivacyPolicy_JP.vue